/**
 * HTML の特殊文字をエスケープします。
 *
 * サイト名・コンテンツタイプ名などは MT にエスケープされずに保存されているため、
 * テンプレート文字列で HTML に埋め込むときは必ず通すこと。
 *
 * @param {*} value エスケープする値（文字列以外は文字列に変換する。null / undefined は空文字）
 * @returns {string} エスケープ済みの文字列
 */
export function escapeHtml(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
